import { makeRequest } from 'utils/requestLogger';

export default (id, dateStart, dateEnd) =>
    makeRequest(
        'get',
        `/api/courses/${id}/get_live_roundtable_engagement/me?dateStart=${dateStart}&dateEnd=${dateEnd}`
    ).then((res) => res.data);


// WEBPACK FOOTER //
// ./src/app/services/courses/getMyLiveRoundtableEngagement.js